import React from 'react';
import { Link } from 'react-router-dom';
import { Check, MapPin } from 'lucide-react';
import { whatsappLink } from '../mock';

export default function PackageCard({ pkg }) {
  return (
    <div className="rounded-2xl overflow-hidden bg-white border border-slate-100 card-lift shadow-sm flex flex-col">
      <Link to={`/packages/${pkg.id}`} className="relative block img-zoom h-56">
        <img src={pkg.image} alt={pkg.title} className="w-full h-full object-cover" loading="lazy" />
        <span className="absolute top-3 left-3 bg-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow">{pkg.duration}</span>
        <span className="absolute top-3 right-3 bg-white/95 backdrop-blur text-navy text-[11px] font-semibold px-2.5 py-1 rounded-full uppercase tracking-wider">{pkg.category}</span>
      </Link>

      <div className="p-5 flex flex-col flex-1">
        <Link to={`/packages/${pkg.id}`}>
          <h3 className="font-serif text-xl font-bold text-navy hover:text-orange-500 transition-colors">{pkg.title}</h3>
        </Link>
        <p className="mt-2 text-sm text-slate-500 flex items-start gap-1.5 leading-relaxed">
          <MapPin className="w-4 h-4 text-orange-500 mt-0.5 shrink-0" />
          <span>{pkg.highlights}</span>
        </p>

        <div className="mt-3 flex flex-wrap gap-2">
          {pkg.inclusions.map((inc) => (
            <span key={inc} className="inline-flex items-center gap-1 text-[11px] font-medium bg-emerald-50 text-emerald-700 px-2 py-1 rounded-md">
              <Check className="w-3 h-3" /> {inc}
            </span>
          ))}
        </div>

        <div className="mt-4 text-sm text-slate-500">Starting from <span className="text-navy text-lg font-bold">₹{pkg.priceFrom.toLocaleString('en-IN')}</span> <span className="text-xs">/ person</span></div>

        <div className="mt-4 pt-4 border-t border-slate-100 flex gap-2">
          <Link to={`/packages/${pkg.id}`} className="flex-1 btn-navy text-center text-sm">View Itinerary</Link>
          <a href={whatsappLink(`I want to book ${pkg.title} package`)} target="_blank" rel="noreferrer" className="flex-1 btn-orange text-center text-sm">Book Now</a>
        </div>
      </div>
    </div>
  );
}
